import React, { useEffect, useState } from 'react';
import { Box, Container, Typography, IconButton, Paper } from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import PivotTabelaProcessada from '../layout/PivotTabelaProcessada';

const PivotViewPage = () => {
    const [data, setData] = useState([]);
    const [title, setTitle] = useState('Análise Dinâmica');

    useEffect(() => {
        const stored = localStorage.getItem('audit_pivot_data');
        if (stored) {
            try {
                const parsed = JSON.parse(stored);
                setData(parsed.data || []);
                setTitle(parsed.title || 'Análise Dinâmica');
            } catch (e) {
                console.error("Erro ao carregar dados do pivot:", e);
            }
        }
    }, []);

    const handleClose = () => {
        window.close();
    };

    return (
        <Box sx={{ bgcolor: '#f5f7fa', minHeight: '100vh', p: 0 }}>
            <Box sx={{ width: '100%' }}>
                <Box display="flex" justifyContent="space-between" alignItems="center" mb={1} px={2} pt={2}>
                    <Typography variant="h5" fontWeight="bold" color="primary">
                        {title}
                    </Typography>
                    <IconButton onClick={handleClose} color="error">
                        <CloseIcon />
                    </IconButton>
                </Box>

                <PivotTabelaProcessada
                    dados={data}
                    defaultRows={['tipo']}
                    defaultCols={['nivel']}
                    defaultVals={[{ field: 'codigo', op: 'Sum' }]}
                />

                <Box mt={2} textAlign="center">
                    <Typography variant="caption" color="textSecondary">
                        SACCI Intelligent Auditor - Tabela Dinâmica
                    </Typography>
                </Box>
            </Box>
        </Box>
    );
};

export default PivotViewPage;
